import { IconFont, pointer } from '@lighthouse/bui'
import styled from 'styled-components'

export const Container = styled.div`
    background: var(--color-gray-100);
    padding-top: 6px;
    border-radius: 8px;

    /* .monaco-editor .monaco-editor-background,
.margin-view-overlays {
  background-color: #E4E7EC !important;
} */

    /* 可选：覆盖滚动条轨道背景色 */
    /* .monaco-editor .scroll-decoration {
  background-color: #E4E7EC !important;
} */
`

export const EditorWrapper = styled.div<{ isFocused?: boolean }>`
    .monaco-editor,
    .monaco-editor .margin,
    .monaco-editor-background {
        background-color: ${props => (props.isFocused ? 'var(--color-gray-200)' : 'var(--color-gray-100)')} !important;
    }
`

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 22px;
    padding: 0 8px;
    margin-bottom: 6px;
`

export const Title = styled.div`
    color: var(--color-gray-900);
    font-size: 14px;
`

// export const DragIcon = styled.div`
//   /* background: var(--color-gray-300); */
//   background: #D0D5DD;
//   /* background: red; */
//   width: 31px;
//   height: 4px;
//   border-radius: 100px;
//   position: absolute;
//   left: 50%;
//   transform: translateX(-50%);
//   bottom: 6px;
//   z-index: 100100100;
// `
